export default {
  SET_ROWS_PER_PAGE (state, rowsPerPage) {
    state.rowsPerPage = rowsPerPage
  }
}



// WEBPACK FOOTER //
// ./src/store/pagination/mutations.js